import type { VisualizationConfig } from '../types/market'

export const visualizationConfig: VisualizationConfig = {
  videoWidth: 1080,
  videoHeight: 1920,
  fps: 60,
  frameDuration: 1000 / 60,
  marketMinuteDuration: 300,
  // Both published cuts stay inside the requested 15–18 second window.
  noonMarketMinuteDuration: 140,
  closeMarketMinuteDuration: 70,
  minRadius: 24,
  maxRadius: 86,
  positiveColor: '#d65c55',
  negativeColor: '#27a37b',
  animationDuration: 280,
  collisionPadding: 7,
  axisGap: 12,
  crossingZoneHalfHeight: 140,
  crossingCollisionScale: 0.42,
  crossingForceStrength: 0.56,
  crossingMaxStep: 24,
  maxCrossingDuration: 760,
  stableProjectionIterations: 28,
  physicsDebug: false,
  topCount: 5,
  safeArea: { top: 100, right: 86, bottom: 220, left: 60 },
  backgroundEffects: true,
  glowIntensity: 0.72,
  particleIntensity: 0.32,
  championEffectEnabled: false,
  championCrownEnabled: true,
  championParticleEnabled: true,
  championParticleMaxCount: 60,
  championParticleRate: 0.16,
  championParticleSpeed: 1,
  championParticleGlow: 0.65,
  championRingIntensity: 0.72,
  championGoldColor: '#FFD76A',
  burstAbsoluteThreshold: 1_500_000_000,
  burstRatioThreshold: 0.85,
  brandName: '索普数据-SOAP Finance',
  audio: {
    backgroundMusic: false,
    voiceOver: false,
    soundEffect: false,
  },
}

export const realVisualizationConfig = {
  minRadius: 32,
  maxRadius: 90,
  collisionPadding: 6,
  safeArea: { ...visualizationConfig.safeArea, bottom: 370 },
  championEffectEnabled: true,
} satisfies Pick<
  VisualizationConfig,
  'minRadius' | 'maxRadius' | 'collisionPadding' | 'safeArea' | 'championEffectEnabled'
>

export function cloneVisualizationConfig(): VisualizationConfig {
  return {
    ...visualizationConfig,
    safeArea: { ...visualizationConfig.safeArea },
    audio: { ...visualizationConfig.audio },
  }
}
